import React, { useContext, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import 'assets/styles/common.scss';
import 'Pages/Doctor/DoctorDashboard/doctorDashboard.scss';
import { LocaleContext } from 'routes/Router';
import { FormattedMessage, useIntl } from 'react-intl';
import ReusableTabs from 'components/commom/Tab';
import UpcomingList from './UpcomingList';
import PendingList from './PendingList';
import RequestList from './RequestList';

const DoctorAppointments = () => {
  const intl = useIntl();
  const [tab, setTab] = useState(1);
  const { locale } = useContext(LocaleContext);

  const tabData = [
    { label: intl.formatMessage({ id: 'Requests' }) },
    { label: intl.formatMessage({ id: 'Upcoming' }) },
    { label: intl.formatMessage({ id: 'Pending Diagnosis' }) },
  ];

  const handleTabChange = (val) => {
    setTab(val);
  };

  return (
    <Row className="bc-FEF9F6 m-0 p-0">
      <Col
        className={
          locale === 'en'
            ? 'commonEnContainer lg:ml-left border-l bColor-EFE3D7'
            : 'commonArContainer lg:mr-right border-l bColor-EFE3D7'
        }
      >
        <h2 className="fc-292D32 fs-32 family_outfit_semiBold_600  m-0">
          <FormattedMessage id="Appointments" />
        </h2>

        <Row className="m-0 p-0 mt-3">
          <Col md={12} lg={8} className="p-0">
            <ReusableTabs
              tabs={tabData}
              defaultTab={tab}
              currentTab={(val) => handleTabChange(val)}
              background={'#864629'}
              color={'#FFFFFF'}
              tabColor={'#998A7B'}
              completeColor={'#FFFFFF'}
            />
          </Col>
        </Row>

        {tab === 1 && <RequestList tab={tab} />}
        {tab === 2 && <UpcomingList tab={tab} />}
        {tab === 3 && <PendingList tab={tab} />}
      </Col>
    </Row>
  );
};

export default DoctorAppointments;
